import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ShareConfigFragmentDoc } from '../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/shareconfig';
import { SharedByWorkspaceFragmentDoc } from '../../../../lyearn-connect/views/LyearnConnectDetails/graphql/fragments/generated/sharedByWorkspace';
import { EventInstructorFragmentDoc } from './EventInstructor';
import { UserFragmentDoc } from '../../../../../graphql/fragments/generated/User';
export type ListEventFragment = { id: string, name: string, description?: string | null, objective: string, status: Types.EventStatusEnum, type: Types.EventTypeEnum, subType: Types.EventSubTypeEnum, latestUpcomingEventId?: string | null, recurringEventSlotCount?: number | null, startTime: string, endTime: string, usersCount: number, isFillingFast: boolean, isUserRegistered: boolean, registrationCloseTime?: string | null, isUserInstructor: boolean, recurringCategory?: Types.RecurringTypeEnum | null, parentEventId?: string | null, shareConfigs?: Array<{ status: Types.ShareConfigStatusEnum, workspaceId: string, sharedAt: string, sharedById: string, sourceWorkspaceEntityId?: string | null }> | null, sharedByWorkspace?: { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null } | null, instructors: Array<{ alias?: string | null, id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }>, cover?: { mediaId: string, name: string, url?: string | null, kind: Types.MediaKindEnum } | null, registrationSettings?: { seatLimit?: number | null, closeRegistrationBeforeStart: number, multiSlotRegistration?: boolean | null } | null };


export type ListEventFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ListEventFragmentDoc = /*#__PURE__*/ gql`
    fragment ListEvent on LiveEventType {
  id
  name
  description
  objective
  status
  type
  subType
  latestUpcomingEventId
  recurringEventSlotCount
  shareConfigs {
    ...ShareConfig
  }
  sharedByWorkspace {
    ...SharedByWorkspace
  }
  instructors {
    ...EventInstructor
  }
  cover {
    mediaId
    name
    url
    kind
  }
  startTime
  endTime
  usersCount
  isFillingFast
  registrationSettings {
    seatLimit
    closeRegistrationBeforeStart
    multiSlotRegistration
  }
  isUserRegistered
  registrationCloseTime
  isUserInstructor
  recurringCategory
  parentEventId
}
    `;